import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DialogBox from "../../components/Comman/dialog-box/DialogBox";
import buttonsData from "./button.json";
import { v4 as uuidv4 } from "uuid"; // Optionally use uuid for unique IDs
import { useDispatch, useSelector } from "react-redux";
import {
  checkDataStructureByAiId,
  deleteById,
  getAiDataByAgentID,
  getAllAiData,
  getBodyData,
  getFooterData,
  getHeaderData,
} from "../../redux/actions/ai_functions";
import { apicall } from "../../services/api";
import { AI_ACTION_TYPES } from "../../redux/actions/actions_ai_type";
import { Add } from "@mui/icons-material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import * as yup from "yup";

export default function DataTable(props) {
  const [open, setOpen] = React.useState(false);
  const [viewStrOpen, setViewStrOpen] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);
  const [aiData, setAiData] = React.useState([]);
  const [selectCampModal, setSelectCampModal] = React.useState(false);

  const validationAiId = yup.object().shape({
    ai_id: yup.string().required("agent is required"),
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(validationAiId),
    defaultValues: {
      ai_id: "",
    },
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const { allAgentDetails, ongoing_ai_id } = useSelector(
  // read all agent details
    (state) => state?.aiDataReducer
  );

  const agentsArr = allAgentDetails?.map((agent) => ({
    id: agent?.ai_id,
    name: agent?.name,
  }));

  console.log(errors, "error");

  // read response for checkStructure for ai id from store
  const checkStructureResponse = useSelector(
    (state) => state?.aiDataReducer?.check_structure_ai_id?.data
  );

  const onFormSubmit = (data) => {
    const { ai_id } = data;
    dispatch(checkDataStructureByAiId(ai_id));
    dispatch(getHeaderData({ agent_id: ai_id, name: "header" }));
    dispatch(getBodyData({ agent_id: ai_id, name: "body" }));
    dispatch(getFooterData({ agent_id: ai_id, name: "footer" }));
  };

  const { setShowDialog, activeTab, setActiveTab } = props;
  const [data, setData] = React.useState(null);

  const dispatch = useDispatch();

  function handleEditClick(id) {
    setShowDialog(true);
    setActiveTab("Structure Creator");
    localStorage.setItem("updatingAgentId", id);
    dispatch(getHeaderData({ agent_id: id, name: "header" }));
    dispatch(getBodyData({ agent_id: id, name: "body" }));
    dispatch(getFooterData({ agent_id: id, name: "footer" }));
  }

  // function to set data null
  async function setAiDataNull() {
    return (dispatch) => {
      dispatch({
        type: AI_ACTION_TYPES.SET_AI_DATA_NULL,
        payload: null,
      });
    };
  }

  async function handleUpdateAgentStructureData() {
    dispatch({
      type: AI_ACTION_TYPES.ONGOING_AGENTID,
      payload: "",
    });
    dispatch({
      type: AI_ACTION_TYPES.CHECK_DATA_STRUCTURE_BY_AI_ID,
      payload: null,
    });
  }

  React.useEffect(() => {
    if (
      checkStructureResponse?.header === true &&
      checkStructureResponse?.body === true &&
      checkStructureResponse?.footer === true
    ) {
      // setSelectCampModal(false);
      // setValue("ai_id", "");
      return;
    } else {
      checkStructureResponse && setShowDialog(true);
      setActiveTab("Structure Creator");
      setSelectCampModal(false);
      setValue("ai_id", "");
    }
  }, [checkStructureResponse]);

  const allAiData = useSelector((state) => state?.aiDataReducer?.all_ai_data);

  React.useEffect(() => {
    dispatch(getAllAiData());
  }, []);

  React.useEffect(() => {
    const formattedRows = allAiData?.map((item) => ({
      ...item,
      id: item?.agent_ai_id || uuidv4(),
      logo: item?.bbpsheader_nav_left_logo?.image,
      seo_title: item?.bbpsheader_seo_title,
      seoDone: item?.bbpsheader_seoDone,
      agent_name: item?.agent_name,
      updatedAt: item?.bbpsheader_updated_at?.slice(0, 10),
    }));
    if (formattedRows?.length > 0) {
      setAiData(formattedRows);
    }
  }, [allAiData]);

  const columns = [
    {
      field: "id",
      headerName: "Agent ID",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "agent_name",
      headerName: "Agent Name",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "seo_title",
    //   headerName: "Seo Title",
    //   width: 120,
    //   headerAlign: "center",
    //   align: "center",
    // },
    {
      field: "logo",
      headerName: "Logo",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <img
            src={params.value}
            alt="logo"
            style={{
              width: 50,
              height: 50,
              borderRadius: "50%",
              objectFit: "contain",
            }}
          />
        </>
      ),
    },
    {
      field: "seoDone",
      headerName: "Seo Done",
      width: 90,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          {params.value === true ? (
            <EmojiEmotionsIcon className="text-success ms-3" />
          ) : (
            <SentimentVeryDissatisfiedIcon className="text-danger ms-3" />
          )}
        </>
      ),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "action",
      headerName: "Action",
      width: 180,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <>
            <div>
              <IconButton
                onClick={() => {
                  setViewStrOpen(true);
                  const selectedRowData = aiData?.find(
                    (data) => data?.id === params.row.id
                  );
                  setModalData(selectedRowData);
                }}
                color="primary"
                title="View"
              >
                <VisibilityIcon />
              </IconButton>
              <IconButton
                onClick={() => handleEditClick(params.row.id)}
                color="info"
                title="Edit"
              >
                <EditIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  dispatch(deleteById(params.row.id));
                  dispatch(getAllAiData());
                  dispatch(setAiDataNull());
                }}
                color="error"
                title="Delete"
                disabled
              >
                <DeleteIcon />
              </IconButton>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Box
        sx={{ height: 380, width: "100%" }}
        style={{ margin: "0px 0px 40px 0px" }}
      >
        <Button
          onClick={() => {
            setSelectCampModal(true);
          }}
          variant="contained"
          style={{ margin: "10px 0px" }}
        >
          Create Structure
        </Button>
        <DataGrid
          rows={aiData}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
          disableDensitySelector
          sx={{
            "& .MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "& .MuiDataGrid-cell": {
              justifyContent: "center",
              display: "flex",
            },
            "& .MuiDataGrid-focusHide": {},
          }}
        />
      </Box>
      <DialogBox data={data} open={open} />
      <Modal
        open={viewStrOpen}
        onClose={() => {
          setViewStrOpen(false);
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 600, height: "auto" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h6 className="text-success my-4">Created structure for</h6>
            &nbsp;
            <span>{modalData?.id}</span>
          </div>

          <div className="d-flex justify-content-around mt-2">
            <div>
              <div style={{ display: "flex", gap: "10px" }}>
                <h6 className="text-success" id="parent-modal-title">
                  Seo Title:&nbsp;{" "}
                </h6>
                <span>{modalData?.seo_title}</span>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <h6 className="text-success" id="parent-modal-title">
                  Seo Done:&nbsp;{" "}
                </h6>
                <span>{modalData?.seoDone ? "Yes" : "No"}</span>
              </div>
            </div>

            <img
              src={modalData?.logo}
              alt=""
              height={150}
              width={150}
              style={{ borderRadius: "100%",objectFit:"contain" }}
            />
          </div>
        </Box>
      </Modal>
      <Modal
        open={selectCampModal}
        onClose={() => {
          if (selectCampModal === true) {
            setSelectCampModal(false);
            setValue("ai_id", "");
            handleUpdateAgentStructureData();
          }
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <Grid
            sx={{
              ...style,
              width: 600,
              // height: 500,
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignContent: "center",
            }}
          >
            <h3 style={{ textAlign: "center", margin: "20px 0px" }}>
              Select Your Agent
            </h3>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <Controller
                name="ai_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="number"
                    select
                    label="Agent"
                    margin="normal"
                    className="w-100"
                    error={errors?.ai_id}
                    helperText={""}
                  >
                    {allAgentDetails.map((item) => (
                      <MenuItem key={item?.ai_id} value={item?.ai_id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />

              <Controller
                name="ai_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    id="Agent"
                    {...field}
                    name="ai_id"
                    label="Agent ID"
                    value={watch("ai_id")}
                    disabled={false}
                    InputProps={{
                      readOnly: true,
                    }}
                  >
                    {agentsArr.map((option, index) => (
                      <MenuItem key={index} value={option.ai_id}>
                        {option.ai_id}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Box>
            <Box sx={{ margin: "40px 0px" }}>
              <Button
                style={{ width: "100%" }}
                variant="contained"
                type="submit"
              >
                Submit
              </Button>
            </Box>
          </Grid>
        </form>
      </Modal>
    </>
  );
}
